import Component from '@glimmer/component';
import layout from './template.hbs';
import './styles.scss';
import { openPostbox, repostMediaToChat } from 'mewe/utils/dialogs-common';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class DocumentOptionsComponent extends Component {
  @service dynamicDialogs;

  get canMove() {
    return this.args.doc.canMove && (!this.args.group || this.args.group.isConfirmed);
  }

  @action
  moveFile() {
    this.dynamicDialogs.openDialog('move-file-dialog', {
      group: this.args.group,
      document: this.args.doc,
    });
  }

  @action
  openPostboxWithTarget(target) {
    if (target === 'chat') {
      const params = {
        fileIds: [this.args.doc.post.document.id],
      };
      repostMediaToChat(params, this.dynamicDialogs);
    } else {
      openPostbox(
        {
          target: target,
          theme: target,
          preselectedFiles: [this.args.doc.post.document],
        },
        this.dynamicDialogs
      );
    }
  }
}
